(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xairex_request"] && !Shopify.designMode) return;
  try {
    
async function getCart() {
  const cart = await fetch('/cart.js').then(r => r.json());

  // テーマエディターで読み込んじゃうのを回避する
  const isThemeEditor = document.documentElement.classList.contains('shopify-design-mode');
  if (!isThemeEditor) {
    // カートが空ならトップへ
    if (cart.item_count === 0) {
      alert('カートに端末情報がありません。');
      location.href = '/collections/frontpage';
      return;
    }
  }

  const container = document.getElementById('cart-items');
  container.innerHTML = '';

  const products = cart.items.map(item => ({
    p_name: item.product_title,
    p_capacity: item.options_with_values[0].value,
    p_color: item.properties['カラー'],
    p_carrier: item.properties['キャリア'],
    p_rank: item.options_with_values[1].value,
    p_quantity: item.quantity,
    p_price: item.final_line_price / 100
  }));
  document.getElementById('products').value = JSON.stringify(products);

  cart.items.forEach(item => {
    const total = item.final_line_price / 100;

    container.insertAdjacentHTML('beforeend', `
      <dl class="dl_style_2">
        <dt>
          <div class="dl_sub_head">査定をご依頼の端末</div>
          <div class="dl_heading">${item.product_title}</div>
        </dt>
        <dd>
          <div class="box_style_3">
            <div class="box_head">容量</div>
            <div class="box_desc">${item.options_with_values[0].value}</div>
          </div>
          <div class="box_style_3">
            <div class="box_head">カラー</div>
            <div class="box_desc">${item.properties['カラー']}</div>
          </div>
          <div class="box_style_3">
            <div class="box_head">キャリア</div>
            <div class="box_desc">${item.properties['キャリア']}</div>
          </div>
          <div class="box_style_3">
            <div class="box_head">状態ランク</div>
            <div class="box_desc">${item.options_with_values[1].value}</div>
          </div>
          <div class="box_style_3">
            <div class="box_head">数量</div>
            <div class="quantity cart-quantity">
              <button class="quantity__button quantity_minus_btn" type="button" data-key="${item.key}">
                <span class="svg-wrapper"><svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-minus" viewBox="0 0 10 2"><path fill="currentColor" fill-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 1 1 0 1H1A.5.5 0 0 1 .5 1" clip-rule="evenodd"></path></svg></span>
              </button>
              <input class="quantity__input" type="number" value="${ item.quantity }" data-key="${item.key}">
              <button class="quantity__button quantity_plus_btn" type="button" data-key="${item.key}">
                <span class="svg-wrapper"><svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-plus" viewBox="0 0 10 10"><path fill="currentColor" fill-rule="evenodd" d="M1 4.51a.5.5 0 0 0 0 1h3.5l.01 3.5a.5.5 0 0 0 1-.01V5.5l3.5-.01a.5.5 0 0 0-.01-1H5.5L5.49.99a.5.5 0 0 0-1 .01v3.5l-3.5.01z" clip-rule="evenodd"></path></svg></span>
              </button>
            </div>
          </div>
          <div class="box_style_4 margin_top_2">
            <div class="">
              <div class="box_heading">概算査定額</div>
              <div class="box_notes">確定額は査定後にご連絡</div>
            </div>
            <div class="box_price">¥${total.toLocaleString('ja-JP')}</div>
          </div>
          <p class="kome_txt">表示は選択内容に基づく目安です。<br>到着後の実機査定で金額が確定します。</p>
          <!-- 
          <div class="dl_btn_wrap">
            <a href="" class="change_btn">
              <svg xmlns="http://www.w3.org/2000/svg" width="18.825" height="18.825" viewBox="0 0 18.825 18.825">
                <g transform="translate(1.414 1)">
                  <path d="M18,20.462l5.744,5.744,2.462-2.462L20.462,18Z" transform="translate(-9.795 -18)" fill="none" stroke="#207a5b" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                  <path d="M16.129,7.1,14.9,13.257,3,16.129l2.872-11.9L12.026,3ZM3,16.129,9.225,9.9" transform="translate(-3 0.282)" fill="none" stroke="#207a5b" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                  <path d="M16.782,15.141a1.641,1.641,0,1,0-1.641,1.641A1.641,1.641,0,0,0,16.782,15.141Z" transform="translate(-7.756 -6.115)" fill="none" stroke="#207a5b" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                </g>
              </svg>
              条件を選び直す
            </a>
          </div>
          -->
          <div class="dl_btn_wrap">
            <button class="delete_btn" type="button" data-key="${item.key}">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
              </svg>
              取り消す
            </button>
          </div>
        </dd>
      </dl>
    `);

  });
  
  console.log(cart.items);
}

getCart();


// 
// 数量-1
// 
document.addEventListener('click', async (e) => {
  const minus = e.target.closest('.quantity_minus_btn');
  if (!minus) return;

  const key = minus.dataset.key;
  const input = minus.parentElement.querySelector('.quantity__input');
  const quantity = Math.max(0, Number(input.value) - 1);

  await fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: key,
      quantity
    })
  });

  location.reload();
});

// 
// 数量+1
// 
document.addEventListener('click', async (e) => {
  const plus = e.target.closest('.quantity_plus_btn');
  if (!plus) return;

  const key = plus.dataset.key;
  const input = plus.parentElement.querySelector('.quantity__input');
  const quantity = Number(input.value) + 1;

  await fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: key,
      quantity
    })
  });

  location.reload();
});

// 
// 数量入力
// 
document.addEventListener('change', async function (e) {
  if (!e.target.classList.contains('quantity__input')) return;
  
  const key = e.target.dataset.key;
  const quantity = Number(e.target.value);

  await fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: key,
      quantity
    })
  });

  // 一覧を再取得して再描画
  location.reload();
});

// 
// 取り消す
// 
document.addEventListener('click', async (e) => {
  if (!e.target.classList.contains('delete_btn')) return;
  // const btn = e.target.closest('.delete_btn');
  // if (!btn) return;

  const key = e.target.dataset.key;

  await fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: key,
      quantity: 0
    })
  });

  // 一覧を再取得して再描画
  location.reload();
});


// 
// submit
// 
async function submitForm(form) {
  const formData = new FormData(form);
  const response = await fetch("https://muu-0ffaef1a27.heteml.net/api/form.php", {
    method: "POST",
    body: formData
  });
  const result = await response.json();
  
  if (!result.success) {
      if (result.errors) {
          alert(Object.values(result.errors).join('\n'));
      } else {
          alert(result.message || '送信に失敗しました。');
      }

      return;
  }

  // カートを空にする
  await fetch('/cart/clear.js', {
    method: 'POST'
  });

  // 完了ページへ
  alert('査定依頼が送信されました。');
  location.href = '/';
}

document.querySelector("#request-form").addEventListener("submit", async (e) => {
  e.preventDefault();
  await submitForm(e.target);
});


// 
// 画像プレビュー
// 
const fileInput1 = document.getElementById('file_1');
const fileInput2 = document.getElementById('file_2');
const preview1 = document.getElementById('preview_1');
const preview2 = document.getElementById('preview_2');

fileInput1.addEventListener('change', function (e) {
    const file = e.target.files[0];

    if (file) {
        const reader = new FileReader();

        reader.onload = function (e) {
            // 既存のプレビュー画像をクリア
            preview1.innerHTML = '';

            // 新しくimgタグを生成
            const newImg = document.createElement('img');
            newImg.src = e.target.result;
            newImg.alt = '表面プレビュー';
            newImg.style.maxWidth = '320px'; // スタイル調整

            // コンテナの中に追加
            preview1.appendChild(newImg);
        }

        // ファイルをData URLとして読み込む
        reader.readAsDataURL(file);
    }
});

fileInput2.addEventListener('change', function (e) {
    const file = e.target.files[0];

    if (file) {
        const reader = new FileReader();

        reader.onload = function (e) {
            // 既存のプレビュー画像をクリア
            preview2.innerHTML = '';

            // 新しくimgタグを生成
            const newImg = document.createElement('img');
            newImg.src = e.target.result;
            newImg.alt = '裏面プレビュー';
            newImg.style.maxWidth = '320px'; // スタイル調整

            // コンテナの中に追加
            preview2.appendChild(newImg);
        }

        // ファイルをData URLとして読み込む
        reader.readAsDataURL(file);
    }
});

  } catch(e) { console.error(e); }
})();
})();
